import styled from "styled-components";
import { motion } from "framer-motion";
import { letterAnimation, textAnimate } from "../animation";

const About = () => {
  return (
    <Section>
      <Container id="about">
        <motion.div
          initial="hide"
          whileInView={"show"}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ staggerChildren: 0.1 }}
          className="title"
        >
          <motion.span variants={letterAnimation}>A</motion.span>
          <motion.span variants={letterAnimation}>B</motion.span>
          <motion.span variants={letterAnimation}>O</motion.span>
          <motion.span variants={letterAnimation}>U</motion.span>
          <motion.span variants={letterAnimation}>T</motion.span>
        </motion.div>
        <motion.div
          initial="hide"
          whileInView={"show"}
          viewport={{ once: true, amount: 0.8 }}
          transition={{ staggerChildren: 0.1 }}
          className="about"
        >
          <motion.p variants={textAnimate}>
            Hi, I'm Iretomiwa Kehinde-Abajo, a Software Developer based in
            Lagos, Nigeria. I specialize in both frontend and backend
            development, using tools like React and Next.js for frontend, and
            Golang for backend. I'm passionate about building clean,
            visually appealing, and intuitive web experiences that solve real
            user problems. I'm a fast learner, always eager to expand my skills.
            Outside of coding, I enjoy reviewing smartphones and laptops,
            listening to music, watching anime, and exploring photography and
            videography.
          </motion.p>
        </motion.div>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  margin-top: 3rem;
  width: 100%;
  min-height: 50vh;
`;

const Container = styled.div`
  width: 85%;
  margin: 0 auto;
  .title {
    text-align: right;
    overflow: hidden;
    span {
      display: inline-block;
      font-family: "Antonio", sans-serif;
      font-weight: 700;
      font-size: 8rem;
      color: rgba(149, 149, 149, 0.2);
    }
  }

  .about {
    overflow: hidden;
    padding: 0 2rem;
    p {
      font-size: 2rem;
      line-height: 4rem;
    }
  }

  @media screen and (max-width: 600px) {
    .title {
      width: 100%;
      span {
        font-size: 4.5rem;
      }
    }

    .about {
      p {
        font-size: 1rem;
        line-height: 2rem;
      }
    }
  }
`;

export default About;
